<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <modal
      modalId="alert-submit-modal"
      ref="alertSubmitModal"
    >
      <div slot="content">
        <p class="modal-pure-text"> {{ $t('vendor.bid.submit.popupTitle') }} </p>
        <span
          class="form-error is-visible appr-error-message"
          v-if="apprErrHint"
        >
          {{ apprErrHint }}
        </span>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          data-close
          aria-label="Close reveal"
        >{{ $t('action.cancel') }}</button>
        <button
          type="submit"
          class="btn btn--orange"
          v-hkldreset
          @click="submitBid()"
        >{{ $t('action.yesSubmit') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/controls/Modal'
export default {
  name: 'SubmitBid',
  data () {
    return {
      apprErrHint: '',
    }
  },
  components: {
    Modal,
  },

  props: {
    className: {
      type: String,
      default: 'btn btn--orange',
    },
  },

  mounted () {
    this.alertSubmitModal = this.$refs.alertSubmitModal
  },

  methods: {
    closeAlertSubmitModal () {
      this.alertSubmitModal.close()
    },
    openAlertSubmitModal () {
      this.alertSubmitModal.open()
    },

    submitBid () {
      this.closeAlertSubmitModal()
      this.$parent.$parent.submit()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
</style>
